import { PluginInitializerService } from 'core-client/api';
import { AstimaxService } from './astimax.service';

export function astimaxInitializerFactory(
  astimaxService: AstimaxService,
  configurationService: PluginInitializerService,
): () => Promise<void> {
  return () =>
    new Promise<void>((resolve) => {
      const init = async () => {
        await astimaxService.setup();
      };

      configurationService.setup('astimax', init, resolve);
    });
}
